export const LOGIN_START = 'LOGIN_START';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const LOGIN_FROM_TOKEN_ERROR = 'LOGIN_FROM_TOKEN_ERROR';

export const CHANGE_LOGIN_DATA = 'CHANGE_LOGIN_DATA';

export const LOGOUT = 'LOGOUT';

export const EDIT_USER = 'EDIT_USER';

export const GET_ME_INFO_ERROR = 'GET_ME_INFO_ERROR';
export const GET_ME_INFO_START = 'GET_ME_INFO_START ';
export const GET_ME_INFO_SUCCESS = 'GET_ME_INFO_SUCCESS';

export const GET_USERS_ERROR = 'GET_USERS_ERROR';
export const GET_USERS_START = 'GET_USERS_START ';
export const GET_USERS_SUCCESS = 'GET_USERS_SUCCESS';

export const GET_ADMINS_ERROR = 'GET_ADMINS_ERROR';
export const GET_ADMINS_START = 'GET_ADMINS_START ';
export const GET_ADMINS_SUCCESS = 'GET_ADMINS_SUCCESS';

export const ACTIVATE_USER_ERROR = 'ACTIVATE_USER_ERROR';
export const ACTIVATE_USER_START = 'ACTIVATE_USER_START ';
export const ACTIVATE_USER_SUCCESS = 'ACTIVATE_USER_SUCCESS';

export const RESET_USER_PASSWORD_ERROR = 'RESET_USER_PASSWORD_ERROR';
export const RESET_USER_PASSWORD_START = 'RESET_USER_PASSWORD_START ';
export const RESET_USER_PASSWORD_SUCCESS = 'RESET_USER_PASSWORD_SUCCESS';

export const UNDELETE_USER_ERROR = 'UNDELETE_USER_ERROR';
export const UNDELETE_USER_START = 'UNDELETE_USER_START ';
export const UNDELETE_USER_SUCCESS = 'UNDELETE_USER_SUCCESS';

export const UPDATE_USER_ERROR = 'UPDATE_USER_ERROR';
export const UPDATE_USER_START = 'UPDATE_USER_START ';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';

export const PAYEE_USER_ERROR = 'PAYEE_USER_ERROR';
export const PAYEE_USER_START = 'PAYEE_USER_START ';
export const PAYEE_USER_SUCCESS = 'PAYEE_USER_SUCCESS';

export const ADMIN_USER_ERROR = 'ADMIN_USER_ERROR';
export const ADMIN_USER_START = 'ADMIN_USER_START ';
export const ADMIN_USER_SUCCESS = 'ADMIN_USER_SUCCESS';

export const GET_DEVICES_START = 'GET_DEVICES_START';
export const GET_DEVICES_ERROR = 'GET_DEVICES_ERROR';
export const GET_DEVICES_SUCCESS = 'GET_DEVICES_SUCCESS';

export const UPDATE_DEVICE_START = 'UPDATE_DEVICE_START';
export const UPDATE_DEVICE_ERROR = 'UPDATE_DEVICE_ERROR';
export const UPDATE_DEVICE_SUCCESS = 'UPDATE_DEVICE_SUCCESS';

export const ADD_LOGO_TO_DEVICE_START = 'ADD_LOGO_TO_DEVICE_START';
export const ADD_LOGO_TO_DEVICE_ERROR = 'ADD_LOGO_TO_DEVICE_ERROR';
export const ADD_LOGO_TO_DEVICE_SUCCESS = 'ADD_LOGO_TO_DEVICE_SUCCESS';

export const TOGGLE_DEVICE_ERROR = 'TOGGLE_DEVICE_ERROR';
export const TOGGLE_DEVICE_START = 'TOGGLE_DEVICE_START';
export const TOGGLE_DEVICE_SUCCESS = 'TOGGLE_DEVICE_SUCCESS';

export const TOGGLE_DEVICE_PUBLIC_ERROR = 'TOGGLE_DEVICE_PUBLIC_ERROR';
export const TOGGLE_DEVICE_PUBLIC_START = 'TOGGLE_DEVICE_PUBLIC_START';
export const TOGGLE_DEVICE_PUBLIC_SUCCESS = 'TOGGLE_DEVICE_PUBLIC_SUCCESS';

export const TOGGLE_DEVICE_FORECAST_ERROR = 'TOGGLE_DEVICE_FORECAST_ERROR';
export const TOGGLE_DEVICE_FORECAST_START = 'TOGGLE_DEVICE_FORECAST_START';
export const TOGGLE_DEVICE_FORECAST_SUCCESS = 'TOGGLE_DEVICE_FORECAST_SUCCESS';

export const TOGGLE_MODAL = 'TOGGLE_MODAL';

export const SET_CURRENT_DEVICE = 'SET_CURRENT_DEVICE';

export const TOGGLE_REPORTS_START = 'TOGGLE_REPORTS_START';
export const TOGGLE_REPORTS_ERROR = 'TOGGLE_REPORTS_ERROR';
export const TOGGLE_REPORTS_SUCCESS = 'TOGGLE_REPORTS_SUCCESS';

export const GET_RECIPIENTS_START = 'GET_RECIPIENTS_START';
export const GET_RECIPIENTS_ERROR = 'GET_RECIPIENTS_ERROR';
export const GET_RECIPIENTS_SUCCESS = 'GET_RECIPIENTS_SUCCESS';

export const ADD_RECIPIENT_START = 'ADD_RECIPIENT_START';
export const ADD_RECIPIENT_ERROR = 'ADD_RECIPIENT_ERROR';
export const ADD_RECIPIENT_SUCCESS = 'ADD_RECIPIENT_SUCCESS';

export const REMOVE_RECIPIENT_START = 'REMOVE_RECIPIENT_START';
export const REMOVE_RECIPIENT_ERROR = 'REMOVE_RECIPIENT_ERROR';
export const REMOVE_RECIPIENT_SUCCESS = 'REMOVE_RECIPIENT_SUCCESS';
export const SET_CURRENT_AREA = 'SET_CURRENT_AREA';

export const GET_AREAS_START = 'GET_AREAS_START';
export const GET_AREAS_ERROR = 'GET_AREAS_ERROR';
export const GET_AREAS_SUCCESS = 'GET_AREAS_SUCCESS';

export const ADD_AREA_START = 'ADD_AREA_START';
export const ADD_AREA_ERROR = 'ADD_AREA_ERROR';
export const ADD_AREA_SUCCESS = 'ADD_AREA_SUCCESS';

export const REMOVE_AREA_START = 'REMOVE_AREA_START';
export const REMOVE_AREA_ERROR = 'REMOVE_AREA_ERROR';
export const REMOVE_AREA_SUCCESS = 'REMOVE_AREA_SUCCESS';

export const UPDATE_AREA_START = 'UPDATE_AREA_START';
export const UPDATE_AREA_ERROR = 'UPDATE_AREA_ERROR';
export const UPDATE_AREA_SUCCESS = 'UPDATE_AREA_SUCCESS';

export const GET_AREA_START = 'GET_AREA_START';
export const GET_AREA_ERROR = 'GET_AREA_ERROR';
export const GET_AREA_SUCCESS = 'GET_AREA_SUCCESS';

export const ADD_AREA_DEVICE_START = 'ADD_AREA_DEVICE_START';
export const ADD_AREA_DEVICE_ERROR = 'ADD_AREA_DEVICE_ERROR';
export const ADD_AREA_DEVICE_SUCCESS = 'ADD_AREA_DEVICE_SUCCESS';

export const REMOVE_AREA_DEVICE_START = 'REMOVE_AREA_DEVICE_START';
export const REMOVE_AREA_DEVICE_ERROR = 'REMOVE_AREA_DEVICE_ERROR';
export const REMOVE_AREA_DEVICE_SUCCESS = 'REMOVE_AREA_DEVICE_SUCCESS';



// WEBPACK FOOTER //
// ./src/actions/actionTypes.js